var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "800px",
        top: "5vh",
        "close-on-click-modal": false,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "section", staticStyle: { width: "100%" } }, [
        _c("div", { staticStyle: { display: "flex" } }, [
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "left",
                display: "flex",
                width: "100%"
              }
            },
            [
              _c("el-input", {
                staticClass: "input-border",
                staticStyle: { width: "700px", "padding-right": "5px" },
                attrs: {
                  placeholder: _vm.$t("CargoMsg.Cargo_inputMblTip"),
                  no: "inputText"
                },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleEnterHandler($event)
                  }
                },
                model: {
                  value: _vm.from.inputText,
                  callback: function($$v) {
                    _vm.$set(_vm.from, "inputText", $$v)
                  },
                  expression: "from.inputText"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right", width: "30%" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { height: "60px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.saveHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              )
            ],
            1
          )
        ]),
        _c("div", { staticStyle: { width: "100%", "padding-top": "5px" } }, [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticStyle: { width: "100%" },
                  attrs: { "label-position": "right", "label-width": "62px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.MasterBillNo") } },
                    [
                      _c("span", { staticStyle: { "font-size": "18px" } }, [
                        _vm._v(" " + _vm._s(_vm.from.mblStr) + " ")
                      ])
                    ]
                  ),
                  _c("div", { staticStyle: { display: "flex" } }, [
                    _c(
                      "div",
                      { staticStyle: { width: "90%", display: "flex" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Terminal") }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "cargoTerminalOperation",
                                "select-type":
                                  _vm.selectTypeNames
                                    .basic_data_AirportCargoTerminal,
                                "method-params": {
                                  dataType: 0,
                                  deletionFlag: false
                                },
                                filterable: "",
                                clearable: true,
                                disabled: true,
                                "default-value": _vm.from.cargoTerminalOperation
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.from.cargoTerminalOperation = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_CustomerName")
                            }
                          },
                          [
                            _c("cargo-company-select", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                "method-params": { customer: true },
                                "default-value": _vm.from.customerId,
                                no: "customerId",
                                disabled: true
                              },
                              on: {
                                change: function(p) {
                                  _vm.from.customerId = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { "text-align": "right", width: "10%" } },
                      [
                        _c(
                          "el-upload",
                          {
                            attrs: {
                              action: "",
                              multiple: "",
                              "auto-upload": false,
                              "show-file-list": false,
                              "on-change": _vm.toChooseFile,
                              no: "1"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { height: "30px" },
                                attrs: { type: "success" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_FileUpload"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    "label-position": "right",
                    "label-width": "62px",
                    disabled: !_vm.isEditing
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_TotalPieces") }
                        },
                        [
                          _c("auto-number-input", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              no: "quantity",
                              "enforce-min": true,
                              precision: 0,
                              min: 0
                            },
                            model: {
                              value: _vm.from.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "quantity", $$v)
                              },
                              expression: "from.quantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_TotalGrossWeight")
                          }
                        },
                        [
                          _c("auto-number-input", {
                            staticStyle: { width: "150px" },
                            attrs: { no: "weight", precision: 3, min: 0 },
                            on: { change: _vm.chargeWeightChange },
                            model: {
                              value: _vm.from.weight,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "weight", $$v)
                              },
                              expression: "from.weight"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_TotalVolume") }
                        },
                        [
                          _c("auto-number-input", {
                            attrs: { no: "volume", precision: 3, min: 0 },
                            on: { change: _vm.chargeWeightChange },
                            model: {
                              value: _vm.from.volume,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "volume", $$v)
                              },
                              expression: "from.volume"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_TotalChargeableWeight"
                            )
                          }
                        },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "chargeWeight",
                              "enforce-min": true,
                              precision: 3,
                              min: 0
                            },
                            model: {
                              value: _vm.from.chargeWeight,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "chargeWeight", $$v)
                              },
                              expression: "from.chargeWeight"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Size") } },
                        [
                          _c("div", [
                            _c(
                              "a",
                              {
                                staticStyle: {
                                  color: "#1F75D5",
                                  "font-size": "16px"
                                },
                                on: { click: _vm.onDimensionFrom }
                              },
                              [_vm._v(_vm._s(_vm.from.measurements) + "✎")]
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("cargo-ag-grid", {
                        ref: "goodsTable",
                        attrs: {
                          "config-module": "20250323",
                          "grid-options": _vm.detailList.gridOptions,
                          "column-defs": _vm.detailList.column,
                          "row-data": _vm.from.dataList || []
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.detailList.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "padding-top": "10px" } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FileInfo")))
                      ]),
                      _c("cargo-ag-grid", {
                        ref: "goodsTable",
                        attrs: {
                          "config-module": "20250324",
                          "grid-options": _vm.fileList.gridOptions,
                          "column-defs": _vm.fileList.column,
                          "row-data": _vm.from.fileList || []
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.fileList.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        {
          staticStyle: { "text-align": "right" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "default" }, on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
          )
        ],
        1
      ),
      _vm.dimensionsDialog.visible
        ? _c("dimensions-dialog", {
            attrs: {
              visible: _vm.dimensionsDialog.visible,
              uuid: _vm.dimensionsDialog.uuid,
              "single-weight": _vm.dimensionsDialog.singleWeight,
              dimension: _vm.dimensionsDialog.dimension
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.dimensionsDialog, "visible", $event)
              },
              sizeData: _vm.sizeDataHandler,
              close: function($event) {
                _vm.dimensionsDialog.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }